angular
  .module('contrast.attacks.attack', [])
  .controller(
    'AttackCtrl',
    function (
      $rootScope,
      $scope,
      $interval,
      $routeSegment,
      $timeout,
      $location,
      ErrorService,
      ChartService,
      AttackMonitorService,
      LoadFilterService,
      UserService,
      AttackFactory,
      REFRESH_DELAY,
      GLOBAL_EVENTS,
      AUTH_EVENTS,
      ATTACK_STATUS
    ) {
      var vm, attacksPoller, timelinePoller

      this.$onInit = function () {
        vm = this
        attacksPoller = null
        timelinePoller = null

        angular.extend(vm, {
          attacks: null,
          severity: null,
          attacksLoaded: false,
          trendLoaded: false,
          activeAttacksPromise: null,

          shortChartData: null,
          shorterChartData: null,
          fullChartData: null,
          eventsCount: 0,
          requestsCount: 0,
          showAttacksChart: false,
          getAttackStatusBadgeStyle: getAttackStatusBadgeStyle
        })

        // TODO: CONTRAST-18296
        // eslint-disable-next-line angular/on-watch
        $rootScope.$on('$locationChangeSuccess', function () {
          if (
            !(
              $routeSegment.startsWith('attacks') ||
              $routeSegment.startsWith('attackOverview')
            )
          ) {
            AttackMonitorService.filters(false)
          }
        })

        // TODO: CONTRAST-18296
        // eslint-disable-next-line angular/on-watch
        $rootScope.$on(AUTH_EVENTS.UNAUTHENTICATED_EVENT, cancelPolling)

        init()
      }

      function init() {
        vm.activeAttacksPromise = getActiveAttacksSummary()
        getChartData()
        $scope.$on('$destroy', _destroy)

        if (!timelinePoller) {
          timelinePoller = $interval(getChartData, REFRESH_DELAY.longDelay)
        } else if (!$routeSegment.startsWith('attacks')) {
          $interval.cancel(timelinePoller)
        }

        if (!attacksPoller) {
          attacksPoller = $interval(
            getActiveAttacksSummary,
            REFRESH_DELAY.mediumDelay
          )
        } else if (
          !(
            $routeSegment.startsWith('attacks') ||
            $routeSegment.startsWith('attackOverview')
          )
        ) {
          $interval.cancel(attacksPoller)
        }
      }

      function getActiveAttacksSummary() {
        return AttackFactory.getActiveAttacksSummary()
          .then(function (response) {
            var data = response.data

            if (vm.attacksLoaded && vm.attacks != data.attacks) {
              vm.attacksLoaded = false
            }

            $timeout(function () {
              var attacksCountChanged =
                vm.attacks != null && vm.attacks != data.attacks

              vm.attacks = data.attacks
              vm.severity = data.severity
              vm.attacksLoaded = true

              $rootScope.$broadcast('attackscount:loaded', attacksCountChanged)
            }, 500)
          })
          .catch(function (response) {
            ErrorService.processError(response)
            cancelPolling()
          })
      }

      function _destroy() {
        if (attacksPoller) {
          $interval.cancel(attacksPoller)
        }
        if (timelinePoller) {
          $interval.cancel(timelinePoller)
        }
      }

      function getAttackStatusBadgeStyle() {
        if (this.attacks > 0) {
          switch (this.severity) {
            case ATTACK_STATUS.BLOCKED.value:
              return 'badge-blocked'
            case ATTACK_STATUS.BLOCKED_PERIMETER.value:
              return 'badge-blocked-perimeter'
            case ATTACK_STATUS.PROBED.value:
              return 'badge-probed'
            case ATTACK_STATUS.PROBED_PERIMETER.value:
              return 'badge-probed-perimeter'
            case ATTACK_STATUS.SUSPICIOUS.value:
              return 'badge-suspicious'
            case ATTACK_STATUS.EXPLOITED.value:
              return 'badge-exploited'

            // No Default
          }
        }
      }

      function getChartData() {
        return AttackMonitorService.getAttackTraffic()
          .then(function (data) {
            vm.shortChartData = ChartService.buildShortAttackMonitorData(
              data.trend_data
            )
            vm.shorterChartData = ChartService.buildShortAttackMonitorData(
              data.trend_data,
              true
            )
            vm.fullChartData = ChartService.buildAttackMonitorData(
              data.trend_data,
              onChartItemClick
            )
            vm.eventsCount = data.total_events
            vm.requestsCount = data.total_requests
            vm.trendLoaded = true
          })
          .catch(function () {
            cancelPolling()
          })
      }

      function onChartItemClick(item) {
        if (item && item.data.key) {
          var time = moment(item.data.key),
            startTime = time.startOf('minute').valueOf(),
            endTime = time.startOf('minute').add(1, 'm').valueOf(),
            datesObj = {
              startDate: startTime,
              endDate: endTime
            }

          if ($routeSegment.startsWith('attacks.events')) {
            $rootScope.$broadcast(
              GLOBAL_EVENTS.ATTACK_EVENTS_DATE_CHANGE,
              datesObj
            )
          } else {
            LoadFilterService.setAttacksDate(datesObj)

            $location.path(UserService.buildUrl('/attacks/events'))
          }
        }
      }

      function cancelPolling() {
        $interval.cancel(attacksPoller)
        $interval.cancel(timelinePoller)
      }
    }
  )
